import { ColorOptions } from '@jfs/ui-new'
import {
  AESEncryption,
  dateFormatter,
  DateFormatTypes,
  getRandomAlphaNumString,
  monthShotForm,
  RSAEncryption,
} from '@jfs/utils'
import { Buffer } from 'buffer'
import CryptoJS from 'crypto-js'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import { JSEncrypt } from 'jsencrypt'
import { Platform } from 'react-native'
import { parseString } from 'react-native-xml2js'
import * as Yup from 'yup'
import { MAX_DAILY_LIMIT, MIN_TRANSFER_AMOUNT, OTP_NOT_REQUIRED_CHANNEL } from './../AppContants'
import { nativeJSComm, nativeJSMapper } from './WebFns'

export const generateRandomString = (length: number) => {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}
export const JIO_PAYMENT_BANK_BIN = '607884'

export const isStatusOK = (data: any) =>
  (data?.httpCode === 200 || data?.httpCode === 'SUCCESS') && data?.status === 'SUCCESS'

export const isStatusCreatedOK = (data: any) => data?.httpCode === 201 || data?.httpCode === 'SUCCESS'

export const isStatusSuccess = (data: any) => data?.status === 'SUCCESS'

export const getNetworkResponseError = (data: any) => {
  console.log('getNetworkResponseError', data)

  let message = 'An unexpected error has occoured'
  let code = -1
  if (data?.error?.message) {
    message = data?.error?.message
    code = data?.error?.code
  } else if (data?.responseData?.message) {
    message = data?.responseData?.message
    code = data?.responseData?.code
  } else if (data?.responseMessage) {
    message = data?.responseMessage
    code = data?.responseCode
  } else if (data?.message) {
    message = data?.message
    code = data?.code
  }

  return { message, code }
}

export const isOsMobile = () => {
  if (Platform.OS === 'android' || Platform.OS === 'ios') {
    return true
  } else {
    return false
  }
}
export const getErrorMessage = (handler: { data: any; state: 'pending' | 'fulfilled' | 'rejected' | undefined }) =>
  handler.state === 'rejected' && handler.data.message

export const pkceGenerateRandomString = (length: number) => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export const pkceGetCodeVerifier = (size: number) => {
  const codeVerifier = pkceGenerateRandomString(size)
  return codeVerifier
}

export const pkceBase64URLEncode = (str: any) => {
  const pkceBase64 = str.toString(CryptoJS.enc.Base64).replace(/[=]/g, '').replace(/\+/g, '-').replace(/\//g, '_')
  return pkceBase64
}

export const pkceBase64URLEncodeValue = (str: any) => {
  if (!str) return '';
  const wordArray = CryptoJS.enc.Utf8.parse(str.toString());
  return wordArray.toString(CryptoJS.enc.Base64)
    .replace(/[=]/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}
export const pkceCodeChallenge = (verifier: string) => {
  const codeChallenge = pkceBase64URLEncode(CryptoJS.SHA256(verifier))
  return codeChallenge
}
export const getEncryptedAuthCodeAndCodeVerifier = (authCode: string, codeVerifier: string, publicKey: string) => {
  const randomEncKey = getRandomAlphaNumString(32)
  const aesAuthEncString = AESEncryption(randomEncKey, authCode)
  const codeVerifierEncString = AESEncryption(randomEncKey, codeVerifier)
  const encryptedKey = RSAEncryption(randomEncKey, publicKey)
  return { codeVerifierEnc: codeVerifierEncString, authCodeEnc: aesAuthEncString, key: encryptedKey }
}

export const AESEncrypt = (securityKey: string, data: string) => {
  let keyUtf8 = Utf8.parse(securityKey)
  let cipherPin = CryptoJS.AES.encrypt(data, keyUtf8, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return cipherPin.ciphertext.toString(Base64)
}
const PUBLIC_ENC_KEY = process.env.REACT_APP_JFS_PUBLIC_KEY ?? ''
export const RSAEncrypt = (key: string) => {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(PUBLIC_ENC_KEY)
  return encrypt.encrypt(key)
}

export const getUTCTimeStamp = () => new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString()

export const getUTCTimeStampp = (options?: { daysAgo?: number }): string => {
  const date = new Date()

  if (options?.daysAgo) {
    date.setDate(date.getDate() - options.daysAgo)
  }

  return date.toISOString()
}

export const getMaskedAadhaarNumber = (aadhaarNo: string) => `XXXX XXXX ${aadhaarNo.slice(-4)}`
export const getMaskedMobileNumber = (mobileNo: string) => `XXXXXX${mobileNo.slice(-4)}`

export const getMaskedVIDNumber = (vid: string) => `XXXX XXXX XXXX ${vid.slice(-4)}`

export const getCarrencyFormat = (amount: number) => new Intl.NumberFormat('en-IN').format(amount)

export const getDecimalAsWhole = (amount: number) => {
  const absamount = +amount | 0
  return (+amount - absamount).toFixed(2).split('.')[1]
}
export const getRoundedNumber = (amount: number) => {
  const intAmount = +amount | 0
  return Math.trunc(intAmount)
}

export const getFormattedAmount = (amount: number) => {
  return `₹ ${getCarrencyFormat(getRoundedNumber(amount))}.${getDecimalAsWhole(amount)}`
}

export const getFromattedTime = (time: string) => dateFormatter(time, DateFormatTypes.DATE_AM_PM)

export const generateRandomNumber = (length: number) => {
  let chars = '0123456789'
  let result = ''
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}

export const formatDDMMYYYDate = (dddmmyyyyDate: string) => {
  if (isNumeric(dddmmyyyyDate)) {
    return `${dddmmyyyyDate.substring(0, 2)} ${monthShotForm[+dddmmyyyyDate.substring(2, 4) - 1]
      } ‘${dddmmyyyyDate.substring(6)}`
  } else {
    return dddmmyyyyDate
  }
}

export const getDDMMMYYDateFromIST = (date: string) => {
  const splitedDate = date?.split(' ')
  if (splitedDate && splitedDate[1] && splitedDate[2] && splitedDate[5]) {
    return `${splitedDate[2]} ${splitedDate[1]} ${splitedDate[5]}`
  }
  return ''
}
export const getDDMMMYYDateFromYYYMMDD = (date: string) => {
  const splitedDate = date?.split('-')
  if (splitedDate && splitedDate[1] && splitedDate[2]) {
    return `${splitedDate[2]} ${monthShotForm[+splitedDate[1] - 1]} ${splitedDate[0]}`
  }
  return ''
}

export const getDDMMMYYDate = (date: Date) =>
  `${date.getDate()}-${monthShotForm[date.getMonth()]}-${date.getFullYear()}`
export const getCurrentMonthStartDate = () => {
  const date = new Date()
  date.setDate(1)
  return date
}

const isNumeric = (num: any) => {
  return !isNaN(parseFloat(num)) && isFinite(num)
}

export const formatRawDateStr = (dateStr: string) => {
  try {
    const splittedDate = dateStr.split(' ')
    const hour = +splittedDate[3].split(':')[0]
    const min = +splittedDate[3].split(':')[1]
    return `${splittedDate[0]}, ${+splittedDate[2]} ${splittedDate[1]}’${+splittedDate[5].substring(2)}, ${formatAMPM(
      hour,
      min,
    )}`
  } catch (err) {
    return ''
  }
}

export const formatAMPM = (hours: number, minutes: number) => {
  let ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`
  var strTime = hours + ':' + minutesString + ' ' + ampm
  return strTime
}

export const getCurrentTimeStamp = () => {
  return new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0] + 'Z'
}

export const getCompleteDate = () => {
  return new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString()
}

export const getFingerPrintData = (fingerPrintData: any, consent?: any, authMode?: 'FACE' | 'FINGER_PRINT',
  otp?: string,
  existingSaTxn?: string
) => {
  let resolve: any

  const promise = new Promise((res) => {
    resolve = res
  })
  parseString(fingerPrintData, { explicitCharkey: true }, function (_: any, { PidData }: any) {
    console.log("DEBUG: Raw Fingerprint Input String:", fingerPrintData);
    const parsedBioMetricData: any = {}
    try {
      const deviceInfo: any = {}
      deviceInfo.dc = PidData.DeviceInfo[0].$.dc
      deviceInfo.dpId = PidData.DeviceInfo[0].$.dpId
      deviceInfo.mc = PidData.DeviceInfo[0].$.mc
      deviceInfo.mi = PidData.DeviceInfo[0].$.mi
      deviceInfo.rdsId = PidData.DeviceInfo[0].$.rdsId
      deviceInfo.rdsVer = PidData.DeviceInfo[0].$.rdsVer

      const captureResponse: any = {}
      captureResponse.PidDatatype = PidData.Data[0].$.type
      captureResponse.Piddata = PidData.Data[0]._

      captureResponse.appCode = 'RILSIMApp'
      captureResponse.ci = PidData.Skey[0].$.ci
      captureResponse.consent = consent ?? 'I have here by allow relience jio to take my biometric for this purpose'
      captureResponse.dc = ''
      captureResponse.dpID = ''
      captureResponse.errCode = PidData.Resp[0].$.errCode
      captureResponse.errInfo = PidData.Resp[0].$.errInfo ?? ''
      captureResponse.fCount = PidData.Resp[0].$.fCount
      captureResponse.fCount = PidData.Resp[0].$.fCount
      captureResponse.fType = PidData.Resp[0].$.fType
      captureResponse.hmac = PidData.Hmac[0]._
      captureResponse.iCount = PidData.Resp[0].$.iCount
      captureResponse.iType = ''
      captureResponse.mc = ''
      captureResponse.mi = ''
      captureResponse.nmPoints = PidData.Resp[0].$.nmPoints
      captureResponse.pCount = PidData.Resp[0].$.pCount
      captureResponse.pType = ''
      captureResponse.qScore = PidData.Resp[0].$.qScore
      captureResponse.rc = 'Y'
      captureResponse.rdsID = '' //not found
      captureResponse.rdsVer = '' //not found
      captureResponse.sa = 'SAPREPROD2'
      captureResponse.saTxn = 'RILSIMApp:' + getCurrentTimeStamp() //need diff format
      captureResponse.sessionKey = PidData.Skey[0]._
      captureResponse.tid = 'registered'
      captureResponse.ver = '2.0'
      captureResponse.saTxn = existingSaTxn ? existingSaTxn : 'RILSIMApp:' + getCurrentTimeStamp()
      if (otp) {
        captureResponse.otp = otp // Transmits along inside JSON structure
      }
      parsedBioMetricData.type = authMode === 'FACE' ? '3' : '1'
      parsedBioMetricData.captureResponse = captureResponse
      parsedBioMetricData.deviceInfo = deviceInfo
    } catch (err) {
      console.log('err', err)
    }
    const finalBase64 = Buffer.from(JSON.stringify(parsedBioMetricData)).toString('base64');

    // 5. LOG FINAL OUTPUT: See what is actually being sent to your API
    console.log("DEBUG: Final Base64 Payload:", finalBase64);

    resolve(finalBase64);
    resolve(Buffer.from(JSON.stringify(parsedBioMetricData)).toString('base64'))
    //lazyAsyncAuthenticateBiometric(isFromEnterAadhaarCardScreen, otp, btoa(JSON.stringify(parsedBioMetricData)))
  })
  return promise
}

export const isObject = (data: any) => typeof data === 'object' && !Array.isArray(data) && data !== null

export const isOTPRequiredChannel = (channelId: any) =>
  !OTP_NOT_REQUIRED_CHANNEL.includes(channelId) || !window?.AepsWebViewInterface

export const Colors = {
  LIGHT_SKY_BLUE: '#DF9F39' as ColorOptions,
  DISABLED_GREY: '#BDBDBD',
}

export const SnakeCase = (str: string) => {
  const newString = str?.toLowerCase().replace('_', ' ')
  function capitalize(string: string) {
    return string?.charAt(0).toUpperCase() + string.slice(1)
  }
  const caps = newString?.split(' ').map(capitalize).join(' ')
  return caps
}

export const getEncryptedPwdAndKey = (pwd: string): any => {
  const randomEncKey = generateRandomString(32)
  const aesEncString = AESEncrypt(randomEncKey, pwd)
  const encryptedKey = RSAEncrypt(randomEncKey)
  return { password: aesEncString, key: encryptedKey }
}

export const CONSTANTS = {
  PENDING: 'PENDING',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
}

export const combineFirstAndLastName = (firstName: string, lastName: string) => {
  return firstName?.trim() + ' ' + lastName?.trim()
}

export const TRANSACTION_CONSTANTS = {
  currency: 356,
  type: 100,
  subType: 500,
  mode: 2,
  captureMethod: 1,
  callbackUrl: 'http://localhost:9002/jfs/v1/plan',
  IMPS: 'IMPS',
}

export const parseJsonString = (value: string) => {
  return value
    .replace(/\\n/g, '\\n')
    .replace(/\\'/g, "\\'")
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, '\\&')
    .replace(/\\r/g, '\\r')
    .replace(/\\t/g, '\\t')
    .replace(/\\b/g, '\\b')
    .replace(/\\f/g, '\\f')
}

export const calculateGrossAmount = (grossAmt: number, chargesArray: Array<Number>) => {
  const results = chargesArray.filter((element) => {
    return element !== null
  })
  const summedArray: any = results?.reduce((e1: any, e2) => e1 + e2)
  return (summedArray + grossAmt) as Number
}

const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
export const formatDateWithTime = (dateInMillis: number) => {
  const date = new Date(dateInMillis)
  let hours = date.getHours()
  let minutes: any = date.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  const strTime = hours + ':' + minutes + ' ' + ampm
  return date.getDate() + ' ' + monthArray[date.getMonth()] + ' ' + date.getFullYear() + ' - ' + strTime
}

export const returnDateString = (str: string) => {
  if (str?.includes('IST')) {
    return str?.split('IST')[0]
  } else {
    return str
  }
}

export const createTransferValidationSchema = (availableDailyLimit: number | undefined) => {
  // 1. Determine the effective max limit
  // const maxLimitIsDynamic = availableDailyLimit && availableDailyLimit > 0 && availableDailyLimit < MAX_DAILY_LIMIT;
  const maxLimitIsDynamic = availableDailyLimit && availableDailyLimit > 0 && availableDailyLimit <= MAX_DAILY_LIMIT
  const maxLimit = maxLimitIsDynamic ? availableDailyLimit : MAX_DAILY_LIMIT
  console.log(maxLimitIsDynamic, maxLimit, availableDailyLimit, 'checkavailablelimitttt:::')
  let maxErrorMessage: string
  const formattedLimit = maxLimit.toLocaleString('en-IN')
  if (maxLimitIsDynamic) {
    maxErrorMessage = `Maximum transaction value is limited to your available daily limit of Rs.${formattedLimit}`
  } else {
    maxErrorMessage = `Maximum transaction value is only upto Rs.${formattedLimit}`
  }
  return Yup.number()
    .min(MIN_TRANSFER_AMOUNT, `Minimum transaction value is Rs.${MIN_TRANSFER_AMOUNT}`)
    .max(maxLimit, maxErrorMessage)
    .required('Required')
    .typeError('Only digits 0-9 are allowed.')
    .test('Test if its a valid', 'Only digits 0-9 are allowed.', (value: number) => {
      if (!value || isNaN(value)) {
        return false
      }
      const numVal = String(value)
      return /^[0-9]*$/.test(numVal)
    })
}

// export const createTransferValidationSchema = (
//   availableDailyLimit: number | undefined,
// ) => {
//   const maxLimit = availableDailyLimit && availableDailyLimit > 0 ? availableDailyLimit : MAX_DAILY_LIMIT;
//   console.log(maxLimit, availableDailyLimit, MAX_DAILY_LIMIT,"checklimitt:::")
//   return Yup.number()
//     .min(MIN_TRANSFER_AMOUNT, `Minimum transaction value is Rs.${ MIN_TRANSFER_AMOUNT } `)
//     .max(maxLimit, `Maximum transaction value is only upto Rs.${ maxLimit.toLocaleString('en-IN') } `)
//     .required('Required')
//     .typeError('Only digits 0-9 are allowed.')
//     .test('Test if its a valid', 'Only digits 0-9 are allowed.', (value: number) => {
//       // Basic digit check
//       if (!value || isNaN(value)) {
//         return false
//       }
//       const numVal = String(value)
//       return /^[0-9]*$/.test(numVal)
//     });
// };

export const maxAndMinAmountForTransferValidation = Yup.number()
  .min(MIN_TRANSFER_AMOUNT, 'Minimum transaction value is Rs.100')
  .max(MAX_DAILY_LIMIT, 'Maximum transaction value is only upto Rs.50,000,000')
  .required('Required')
  .typeError('Only digits 0-9 are allowed.')
  .test('Test if its a valid', 'Only digits 0-9 are allowed.', (value: number) => {
    if (!value) {
      return false
    }
    if (isNaN(value)) {
      return false
    }
    const numVal = String(value)
    return /^[0-9]*$/.test(numVal)
  })

export const getMaskedAccountNumber = (data: string | number) => {
  if (String(data)?.length > 1) {
    return 'X'.repeat((data + '')?.length - 4) + (data + '').slice(-4)
  }
  return ''
}

export const isValidIfsc = (ifscCode: string) => ifscCode?.length === 11

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms))

export const addCountryCode = (mobileNo: string | null | undefined) =>
  !mobileNo || mobileNo.length < 2 ? '' : '+91 ' + mobileNo

export const parseBioMetricDeviceInfo = (fingerData) => {
  const parseFingerData = JSON.parse(atob(fingerData))
  if (parseFingerData?.deviceInfo?.mc) {
    parseFingerData.deviceInfo.mc = ''
  }
  parseFingerData.captureResponse = {}
  return JSON.stringify(parseFingerData)
}
export const parseXmlToJson = (xml: string, options = {}) => {
  const promise = new Promise((resolve: any, reject: any) => {
    parseString(xml, options, (err: any, parsedJson: any) => {
      if (err && err !== null) {
        reject(err)
      } else {
        resolve(parsedJson)
      }
    })
  })
  return promise
}
export const getFingerPrintDataXML = (fingerPrintData: any, aadhaarNo: string, consent: string) => {
  console.log('fingerPrintData', fingerPrintData)
  let resolve: any

  const promise = new Promise((res) => {
    resolve = res
  })
  const onFingerPrintDataFormated = (formatedFingerPrintData: string) => {
    console.log('formatedFingerPrintData', formatedFingerPrintData)
    resolve(formatedFingerPrintData)
  }
  nativeJSComm(nativeJSMapper.formatFingerPrintData, onFingerPrintDataFormated, undefined, {
    fingerPrintData,
    aadhaarNo,
    consent,
  })
  return promise
}

export const calculateTotalConvinianceFee = (transactions) =>
  transactions.reduce((total, { grossAmount, amount }) => total + (grossAmount - amount), 0)



export const parseQueryString = (url: string): { [key: string]: string } => {
  const query = url.split('?')[1];
  if (!query) return {};

  return query.split('&').reduce((acc, pair) => {
    const [key, value] = pair.split('=');
    if (key && value) {
      acc[decodeURIComponent(key.toLowerCase())] = decodeURIComponent(value);
    }
    return acc;
  }, {} as { [key: string]: string });
};